import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class AmbientSensor extends Sensor {
  public tempAmbChart: any;
  public ambPressureChart: any;
  public ambDpvChart: any;
  public ambdewPointChart: any;
  public ambHumidityChart: any;

  private ambTempSensor: any[];
  private ambPreasureSensor: any[];
  private ambDpvSensor: any[];
  private ambdewPointSensor: any[];
  private ambHumiditySensor: any[];
  public hasPres: boolean;

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.tempAmbChart = null;
    this.ambPressureChart = null;
    this.ambdewPointChart = null;
    this.ambHumidityChart = null;
    this.ambDpvChart = null;

    this.ambTempSensor = [[], [], []];
    this.ambPreasureSensor = [[], [], []];
    this.ambdewPointSensor = [[], [], []];
    this.ambHumiditySensor = [[], [], []];
    this.ambDpvSensor = [[], [], []];
    this.hasPres = false;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.ambTempSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);
      this.ambHumiditySensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.humidity,
      ]);
      this.ambDpvSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.dpv,
      ]);
      this.ambdewPointSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.dewPoint,
      ]);
      if (element.preasure != null) {
        this.hasPres = true;
        this.ambPreasureSensor[element.position].push([
          GraphUtils.getDateUtc(date),
          element.preasure,
        ]);
      }
    }
  }

  public hasDpvSensor(pos: number): boolean {
    return this.ambDpvSensor[pos - 1].length > 0;
  }

  public getDpvSensor(pos: number): any {
    const realPos: number = this.ambDpvSensor[pos - 1].length - 1;
    return this.ambDpvSensor[pos - 1][realPos][1] ?? null;
  }

  public hasTempSensor(pos: number): boolean {
    return this.ambTempSensor[pos - 1].length > 0;
  }

  public getTempSensor(pos: number): any {
    const realPos: number = this.ambTempSensor[pos - 1].length - 1;
    return this.ambTempSensor[pos - 1][realPos][1] ?? null;
  }

  public hasPressSensor(pos: number): boolean {
    return this.ambPreasureSensor[pos - 1].length > 0;
  }

  public getPressSensor(pos: number): any {
    const realPos: number = this.ambPreasureSensor[pos - 1].length - 1;
    return this.ambPreasureSensor[pos - 1][realPos][1] ?? null;
  }

  public hasDpSensor(pos: number): boolean {
    return this.ambdewPointSensor[pos - 1].length > 0;
  }

  public getDpSensor(pos: number): any {
    const realPos: number = this.ambdewPointSensor[pos - 1].length - 1;
    return this.ambdewPointSensor[pos - 1][realPos][1] ?? null;
  }

  public hasHumSensor(pos: number): boolean {
    return this.ambHumiditySensor[pos - 1].length > 0;
  }

  public getHumSensor(pos: number): any {
    const realPos: number = this.ambHumiditySensor[pos - 1].length - 1;
    return this.ambHumiditySensor[pos - 1][realPos][1] ?? null;
  }

  public setCharts(): void {
    this.tempAmbChart = this.getConfigChar(
      'tempAmbChart',
      this.getChartSeries('TAmb', this.ambTempSensor),
      this.getRanges('3_temperature'),
      this.getLimits('3_temperature')
    );
    this.ambDpvChart = this.getConfigChar(
      'ambDpvChart',
      this.getChartSeries('DPV', this.ambDpvSensor),
      this.getRanges('3_dpv'),
      this.getLimits('3_dpv')
    );
    this.ambPressureChart = this.getConfigChar(
      'ambPressureChart',
      this.getChartSeries('Press', this.ambPreasureSensor),
      this.getRanges('3_preasure'),
      this.getLimits('3_preasure')
    );
    this.ambdewPointChart = this.getConfigChar(
      'ambdewPointChart',
      this.getChartSeries('TRocio', this.ambdewPointSensor),
      this.getRanges('3_dewPoint'),
      this.getLimits('3_dewPoint')
    );
    this.ambHumidityChart = this.getConfigChar(
      'ambHumidityChart',
      this.getChartSeries('HR', this.ambHumiditySensor),
      this.getRanges('3_humidity'),
      this.getLimits('3_humidity')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura', value: '3_temperature' },
      { title: 'Humedad relativa', value: '3_humidity' },
      { title: 'Presión barométrica', value: '3_preasure' },
      { title: 'Punto de rocio', value: '3_dewPoint' },
      { title: 'Déficit de presión de vapor', value: '3_dpv' },
    ];
  }
}